<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M8.14,798.59V782.5H-7.14v16.09l7.6,3.91L8.14,798.59z M-6.4,783.24H7.4v14.89l-6.94,3.52l-6.85-3.52V783.24z M4.98,794.28
	v2.32l-4.57,2.32l-4.4-2.26v-2.33l4.4,2.26L4.98,794.28z"/>
</svg>

</template>